export const themeColor = "#EE7531";
export const themeOrange = "#EE7531";
export const themeBlue = "#254665";
export const deepBlue = "#0076BA";
export const errorRed = "#E94C4C";
export const successGreen = "#16A000";
export const warningYellow = "#e1c200";
